<template>
  <section  class="ew-height">
    <navbar-dashboard name="Editar paquete" v-if="currentStep === 1"></navbar-dashboard>
    <section class="ew-smaller-container" v-if="currentStep === 1">
      <div class="ew-card">
        <form class="ew-form" @submit.prevent="sendParcel">
          <div class="ew-package-type">
            <p class="ew-package-type__title">Tipo de paquete</p>
            <div class="ew-package-type__options">
              <label class="ew-radio-pill" :class="{ 'is-active': package_type === 'document' }">
                <input type="radio" name="package_type" @click="package_type = 'document'">
                <span>Documento</span>
              </label>
              <label class="ew-radio-pill" :class="{ 'is-active': package_type === 'box' }">
                <input type="radio" name="package_type" @click="package_type = 'box'">
                <span>Paquete</span>
              </label>
              <!-- "tarima" es el valor que reconoce serviceEpak.js; con
                   "pallet" cotizaba como paquete normal. -->
              <label class="ew-radio-pill" :class="{ 'is-active': package_type === 'tarima' }">
                <input type="radio" name="package_type" @click="package_type = 'tarima'">
                <span>Tarima</span>
              </label>
            </div>
          </div>

          <div class="ew-parcels__row" v-for="(parcel, index) in parcels" v-bind:key="index">
            <div class="ew-form__field" v-if="package_type !== 'document'">
              <label class="ew-label">Largo</label>
              <input type="number" min="1" class="ew-input" v-model="parcels[index].width" required>
            </div>
            <div class="ew-form__field" v-if="package_type !== 'document'">
              <label class="ew-label">Ancho</label>
              <input type="number" min="1" class="ew-input" v-model="parcels[index].depth" required>
            </div>
            <div class="ew-form__field" v-if="package_type !== 'document'">
              <label class="ew-label">Altura</label>
              <input type="number" min="1" class="ew-input" v-model="parcels[index].height" required>
            </div>
            <div class="ew-form__field">
              <label class="ew-label">Peso</label>
              <input type="number" class="ew-input" v-model="parcels[index].weight" required>
            </div>
            <button class="ew-clean-btn" type="button" v-if="package_type !== 'document'" @click="removeParcel(index)">
              <img src="@/assets/images/Eliminar.svg" alt="Quitar">
            </button>
          </div>

          <button class="ew-link-btn" type="button" v-if="package_type !== 'document'" @click.prevent="addParcel">Agregar otro paquete</button>

          <div class="ew-form__actions">
            <router-link class="ew-btn-outline" :to="'/shipments/' + $route.params['id']">Cancelar</router-link>
            <button class="ew-btn-primary" type="submit">Seleccionar paquetería</button>
          </div>
        </form>
      </div>
    </section>

    <ServiceProviderSelector v-if="currentStep === 2" :origin="origin_direction" :destination="destination_direction" :package-type="package_type" :parcels="parcels" :insurance="insurance_information" :primary-action-text="primaryActionText" :secondary-action-text="secondaryActionText" @primary-action="updateShipmentWithNewSO" @secondary-action="currentStep = 1" />
  </section>
</template>

<script>
import axios from 'axios'
import commons from '../../commons'
import api from '../../commons/api'
import ServiceProviderSelector from '../ServiceProviderSelector'
import { mapGetters, mapActions, mapMutations } from 'vuex'
import Navbar from '../Header/Navbar'
export default {
  name: 'EditShipmentDestination',
  data () {
    return {
      currentStep: 1,
      initialParcels: [],

      selectedShippingOptionIndex: -1,

      package_type: '',

      origin_direction: {
        full_name: '',
        email: '',
        phone: '',
        address: '',
        reference_of_origin: '',
        colony: '',
        postal_code: '',
        state_code: '',
        city: '',
        country_code: 'MX'
      },

      destination_direction: {
        full_name: '',
        email: '',
        phone: '',
        address: '',
        reference_of_origin: '',
        colony: '',
        postal_code: '',
        state_code: '',
        city: '',
        country_code: 'MX'
      },

      description_of_the_content: '',
      package_insurance: false,

      insurance_information: {
        package_value: null,
        responsible_for_the_package: null,
        mail_responsible: null,
        cost: null
      },

      parcels: [
        {
          depth: '',
          width: '',
          height: '',
          weight: ''
        }
      ],

      requestBody: {
        origin_direction: {
          country_code: '',
          postal_code: '',
          city: '',
          suburb: ''
        },

        parcels: [
          {
            weight: '',
            height: '',
            depth: '',
            width: ''
          }
        ],
        destination_direction: {
          country_code: '',
          postal_code: '',
          city: '',
          suburb: ''
        },
        insured_value: '',
        insured_value_currency: 'MXN'
      },

      primaryActionText: 'Aplicar Cambios',
      secondaryActionText: 'Cancel'
    }
  },
  methods: {
    sendParcel () {
      if (this.package_type === 'document') {
        this.parcels[0].height = '41'
        this.parcels[0].width = '31'
        this.parcels[0].depth = '1'
        this.parcels.length = 1
        this.currentStep = 2
      } else {
        this.currentStep = 2
      }
    },
    addParcel () {
      this.parcels.push({
        depth: '',
        width: '',
        height: '',
        weight: ''
      })
    },
    removeParcel (index) {
      if (this.parcels.length > 1) {
        this.parcels.splice(index, 1)
        console.log(this.parcels)
      }
    },
    nextStep () {
      if (this.currentStep < 6) {
        this.step++
      }
    },
    prevStep () {
      if (this.currentStep > 1) {
        this.step--
      }
    },

    updateShipment () {
      this.setSelectedShippingOption(
        this.shippingOptions[this.selectedShippingOptionIndex]
      )

      const requestBody = {
        parcels: this.parcels
      }

      this.setNewShipmentRequestBody(requestBody)
      api.shipment.update(this.$route.params['id'], requestBody).then(() => {
        this.getAllShipments()
        this.$router.push(`/shipments/${this.$route.params['id']}`)
      })
    },

    updateShipmentWithNewSO (newSO) {
      const requestBody = {
        parcels: this.parcels,
        selected_service: newSO,
        shipment_type: this.package_type
      }

      this.setNewShipmentRequestBody(requestBody)

      api.shipment.update(this.$route.params['id'], requestBody).then(() => {
        this.getAllShipments()
        this.$router.push(`/shipments/${this.$route.params['id']}`)
      })
    },

    calculateQuote () {
      console.log('calculateQuote 3333')

      this.requestBody.parcels = this.parcels

      this.requestBody.origin_direction = {
        country_code: this.origin_direction.country_code,
        postal_code: this.origin_direction.postal_code,
        city: this.origin_direction.city,
        suburb: this.origin_direction.colony
      }

      this.requestBody.destination_direction = {
        country_code: this.destination_direction.country_code,
        postal_code: this.destination_direction.postal_code,
        city: this.destination_direction.city,
        suburb: this.destination_direction.colony
      }

      this.requestBody.package_type = this.package_type

      if (this.package_insurance) {
        this.insured_value = this.insurance_information.cost
      } else {
        delete this.insured_value
      }

      this.setQuotingRequestBody(this.requestBody)

      this.quoting()
        .then(() => {
          this.nextStep()
        })
        .catch(error => console.log(error))
    },

    createShipment () {
      this.setSelectedShippingOption(
        this.shippingOptions[this.selectedShippingOptionIndex]
      )

      const requestBody = {
        selected_service: {
          full_name: this.selectedShippingOption.product_short_name,
          mount: this.selectedShippingOption.shipping_charge,
          logo_url: this.selectedShippingOption.logo_url,
          delivery_time: this.selectedShippingOption.delivery_date,
          pickup_date: this.selectedShippingOption.pickup_date,
          currency_code: this.selectedShippingOption.currency_code
        },
        shipment_type: this.package_type,
        parcels: this.quotingRequestBody.parcels,
        origin_direction: this.origin_direction,
        destination_direction: this.destination_direction,
        description_of_the_content: this.description_of_the_content,
        package_insurance: this.package_insurance,
        insurance_information: this.insurance_information,
        user: localStorage.getItem('ew-user-id')
      }

      this.setNewShipmentRequestBody(requestBody)
      this.newShipment().then(() => {
        this.getAllShipments()
        this.$router.push('/dashboard')
      })
    },

    checkAddressOrigin (event) {
      // console.log(event)
      const query = event.target.value
      if (query.length >= 3) {
        this.getLocationInfo(query, 'MX').then(response => {
          console.log(response.data)
          this.origin_direction.city =
            response.data[0].parish + ', ' + response.data[0].state
        })
      }
    },
    checkAddressDestination (event) {
      // console.log(event)
      const query = event.target.value
      if (query.length >= 3) {
        this.getLocationInfo(query, 'MX').then(response => {
          // console.log(response.data)
          this.destination_direction.city =
            response.data[0].parish + ', ' + response.data[0].state
        })
      }
    },
    getLocationInfo (zipCode, countryCode) {
      return axios.get(
        `${
          commons.apiURL
        }/api/v1/postalcode?zipCode=${zipCode}&country=${countryCode}`
      )
    },
    ...mapMutations([
      'netNewShipmentRequestBody',
      'setQuotingRequestBody',
      'setSelectedShippingOption',
      'setNewShipmentRequestBody'
    ]),
    ...mapActions(['quoting', 'newShipment', 'getAllShipments'])
  },
  computed: {
    ...mapGetters([
      'quotingRequestBody',
      'selectedShippingOption',
      'serviceProviders',
      'shippingOptions'
    ])
  },
  components: {
    ServiceProviderSelector: ServiceProviderSelector,
    'navbar-dashboard': Navbar
  },
  created () {
    api.shipment.getByID(this.$route.params['id']).then(response => {
      this.origin_direction = response.data.origin_direction
      this.destination_direction = response.data.destination_direction
      this.parcels = response.data.parcels
      this.insurance_information = response.data.insurance_information
      this.initialOriginZipCode = this.origin_direction.postal_code
      this.package_type = response.data.shipment_type
    })
  }
}
</script>

<style scoped lang="scss">
@import "../../assets/styles/app-tokens";
@import "../../assets/styles/ew-components";

.ew-smaller-container { @include app-tokens; max-width: 700px; margin: 2.5rem auto; padding: 0 1rem 4rem; }
.ew-card { @include ew-card; padding: 1.5rem 1.75rem; }
.ew-btn-primary { @include ew-btn-primary; }
.ew-btn-outline { @include ew-btn-outline; }
.ew-form { display: flex; flex-direction: column; gap: 1rem; max-width: none; }
.ew-form__field { display: flex; flex-direction: column; gap: 0.4rem; margin-bottom: 0; }
.ew-form__actions { display: flex; justify-content: flex-end; gap: 0.6rem; margin-top: 0.5rem; }
.ew-label { font-family: var(--app-font); font-size: 0.8rem; font-weight: 700; color: var(--app-navy); }
.ew-input { @include ew-input; }

.ew-package-type { text-align: center; margin-bottom: 0.5rem; }
.ew-package-type__title { font-family: var(--app-font); font-weight: 700; color: var(--app-navy); margin-bottom: 0.75rem; }
.ew-package-type__options { display: flex; justify-content: center; gap: 0.75rem; flex-wrap: wrap; }
.ew-radio-pill {
  display: inline-flex;
  align-items: center;
  height: 2.5rem;
  padding: 0 1.25rem;
  border: 1.5px solid var(--app-border);
  border-radius: 999px;
  font-family: var(--app-font);
  font-size: 0.85rem;
  font-weight: 700;
  color: var(--app-navy);
  cursor: pointer;

  input { position: absolute; opacity: 0; width: 0; height: 0; }
  &.is-active { border-color: var(--app-accent); background: var(--app-surface-muted); }
}

.ew-parcels__row {
  display: flex;
  align-items: flex-end;
  flex-wrap: wrap;
  gap: 1rem;
  margin-bottom: 0.75rem;
  > .ew-form__field { flex: 1 1 140px; min-width: 0; }
}

.ew-link-btn {
  display: block;
  border: none;
  background: none;
  padding: 0;
  margin-bottom: 1rem;
  font-family: var(--app-font);
  font-size: 0.82rem;
  font-weight: 700;
  color: var(--app-accent-button);
  &:hover { text-decoration: underline; }
}
</style>



// WEBPACK FOOTER //
// src/components/editShipment/EditShipmentParcels.vue